import { Component, Output, EventEmitter, Input } from '@angular/core';
import moment from 'moment';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import { ViewController, Events } from 'ionic-angular';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';

/**
 * Generated class for the CoCalendarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-calendar',
  templateUrl: 'co-calendar.html'
})
export class CoCalendarComponent {
  @Input() range: boolean = false;
  currentMonth: any = moment();
  eventsInThisMonth: Array<string> = [];
  daysInThisMonth: any;
  daysInLastMonth: any;
  daysInNextMonth: any;
  currentDay: any = '';
  currentMonthEvents: any = [];
  parentPage: any;
  selectedDate: any;
  rangeFirstDate: any = '';
  rangeLastDate: any = '';
  rangeSelectingAnotherDate: boolean = false;
  isInPopup: boolean = false;
  showHeader: boolean = false;
  calendarLine: Array<string> = [];
  @Output() onDatePicked: EventEmitter<any> = new EventEmitter<any>();

  constructor(public navParams: NavParams, private viewCtrl: ViewController, private toast: ToastAlertsProvider, private events : Events, private timeout : TimeoutFunctionsProvider) {
    if (this.navParams.data) {
      this.range = this.navParams.data.range;
      this.isInPopup = this.navParams.data.popup;
      this.showHeader = this.navParams.data.popup;
    }
    if (this.isInPopup) this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
  }

  ngOnInit() {
    if (this.navParams.data.currentDay) {
      this.monthClicked(this.navParams.data.currentDay);
      this.parentPage = this.navParams.data.reservePage;
    } else {
      this.monthClicked(moment().format("YYYY-MM-DD HH:mm:ss"));
    }
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.resetCalendar();
  }

  getDaysOfMonth() {
    this.daysInThisMonth = new Array();
    this.daysInLastMonth = new Array();
    this.daysInNextMonth = new Array();

    // var firstDayThisMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth(), 1).getDay();
    var firstDayThisMonth = this.currentMonth.startOf('month').day();
    // var prevNumOfDays = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth(), 0).getDate();
    // var prevNumOfDays = this.currentMonth.date();
    // for (let i = prevNumOfDays - (firstDayThisMonth - 1); i <= prevNumOfDays; i++) {
    //   this.daysInLastMonth.push('');
    // }
    for (let i = firstDayThisMonth; i > 0; i--) {
      this.daysInLastMonth.push('');
    }

    // var thisNumOfDays = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 0).getDate();
    var thisNumOfDays = this.currentMonth.endOf('month').date();
    for (let i = 0; i < thisNumOfDays; i++) {
      this.daysInThisMonth.push(i + 1);
    }

    // var lastDayThisMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 0).getDay();
    var lastDayThisMonth = this.currentMonth.endOf('month').day();
    var totalDays = this.daysInLastMonth.length + this.daysInThisMonth.length + this.daysInNextMonth.length;
    if (totalDays < 36) {
      for (let i = (7 - lastDayThisMonth); i < ((7 - lastDayThisMonth) + 7); i++) {
        this.daysInNextMonth.push('');
      }
    // } else if (totalDays >= 36 && totalDays < 43){
    //   for (let i = (7 - lastDayThisMonth); i < ((7 - lastDayThisMonth) + 7); i++) {
    //     this.daysInNextMonth.push('');
    //   }
    }
  }

  loadMonthEvents(eventsInMonth: any) {
    let eventsArray = eventsInMonth.reduce((res, element) => {
      let start = moment(element.eventStart).date();
      if (!res[start]) {
        res[start] = 0;
      }
      res[start]++;
      return res;
    }, {});
    this.eventsInThisMonth = eventsArray;
    this.getDaysOfMonth();
  }

  goToMonth(date: string) {
    this.currentDay = moment(date).date();
    // this.currentMonth = new Date(moment(date).year(), moment(date).month(), this.currentDay);
    this.currentMonth = moment(date);
    // console.log(date, this.currentDay, this.currentMonth);

    this.getDaysOfMonth();
  }

  changeSelectedDate(data: any) {
      if (data.target.innerText === '') {
        return;
      }
      if (!this.range) {
        // this.currentDay = new Date(moment(this.currentMonth).year(), moment(this.currentMonth).month(), data.target.innerText).getDate();
        this.currentDay = parseInt(moment(this.currentMonth).date(data.target.innerText).format('D'));
        this.selectedDate = moment(this.currentMonth).date(parseInt(data.target.innerText)).format('D MMMM YYYY');
        this.onDatePicked.emit(moment(this.currentMonth).date(parseInt(data.target.innerText)).toString());
        // console.log(data, this.currentDay, this.selectedDate);
      } else {
        if (!this.rangeSelectingAnotherDate) { //if first selection click
          this.rangeSelectingAnotherDate = true;
          this.rangeFirstDate = moment().year(this.currentMonth.year()).month(this.currentMonth.month()).date(parseInt(data.target.innerText));
          this.rangeLastDate = undefined;
          this.onDatePicked.emit({fromDate: this.rangeFirstDate, toDate: this.rangeLastDate});
        } else {
          this.rangeSelectingAnotherDate = false;
          this.rangeLastDate = moment().year(this.currentMonth.year()).month(this.currentMonth.month()).date(parseInt(data.target.innerText));
          if (this.rangeFirstDate.isAfter(this.rangeLastDate)) {
            let firstDate = this.rangeLastDate;
            this.rangeLastDate = this.rangeFirstDate;
            this.rangeFirstDate = firstDate;
          }
          this.onDatePicked.emit({fromDate: this.rangeFirstDate, toDate: this.rangeLastDate});
        }
      }
  }

  checkDates(day) {
    if (this.range) {
      if (this.rangeFirstDate && !this.rangeLastDate) {
        if (this.rangeFirstDate.date() === day && this.rangeFirstDate.isSame(this.currentMonth, 'month')) {
          return true;
        }
      } else if (this.rangeFirstDate && this.rangeLastDate) {
        // let date = this.currentMonth.date(day);
        let date = moment().year(this.currentMonth.year()).month(this.currentMonth.month()).date(day);
        if (date.isBetween(this.rangeFirstDate, this.rangeLastDate) || date.isSame(this.rangeFirstDate, 'day') || date.isSame(this.rangeLastDate, 'day')) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  closeCalendar(ok) {
    if (!ok) {
      this.viewCtrl.dismiss(false, "", {animate: false});
    } else {
      if (this.range) {
        // console.log(this.range, this.rangeFirstDate, this.rangeLastDate);
        if (this.rangeFirstDate && this.rangeLastDate && this.rangeFirstDate !== '' && this.rangeLastDate !== '') {
          this.viewCtrl.dismiss({from: this.rangeFirstDate, to: this.rangeLastDate}, "", {animate: false});
        } else {
          this.toast.triggerToast('Invalid date range', '', 'warning', 5000);
        }
      } else {
        if (this.currentDay && this.currentDay > 0) {
          this.viewCtrl.dismiss({date: this.selectedDate}, "", {animate: false});
        } else {
          this.toast.triggerToast('Invalid date', '', 'warning', 5000);
        }
      }
    }
  }

  generateRangeString() {
    let final = '';
    if (this.rangeFirstDate && this.rangeFirstDate !== '') {
      final += this.rangeFirstDate.format('D MMM YYYY - ').toUpperCase();
    }
    if (this.rangeLastDate && this.rangeLastDate !== '') {
      if (this.rangeFirstDate.year() === this.rangeLastDate.year()) {
        if (this.rangeFirstDate.month() === this.rangeLastDate.month()) {
          if (this.rangeFirstDate.date() === this.rangeLastDate.date()) {
            final = this.rangeFirstDate.format('D MMM YYYY').toUpperCase();
          } else {
            final = this.rangeFirstDate.format('D').toUpperCase() + ' - ' + this.rangeLastDate.format('D MMM YYYY').toUpperCase();
          }
        } else {
          final = this.rangeFirstDate.format('D MMM').toUpperCase() + ' - ' + this.rangeLastDate.format('D MMM YYYY').toUpperCase();
        }
      } else {
        final += this.rangeLastDate.format('D MMM YYYY').toUpperCase();
      }
    }
    return final;
  }

  resetCalendar() {
    this.rangeFirstDate = undefined;
    this.rangeLastDate = undefined;
    this.currentDay = moment().date();
    this.selectedDate = moment().format("D MMMM YYYY");
  }

  calendarLoad(date: string) {
    let selectedDate = moment(date).startOf('month').subtract(2, 'month').format("YYYY-MM-DD HH:mm:ss");
    this.calendarLine = [];
    for (let x = 0; x < 5; x++) {
      this.calendarLine.push(moment(selectedDate).startOf('month').add(x, 'month').format("YYYY-MM-DD HH:mm:ss"))
    };
  };

  previousMonths(date: string) {
    let selectedDate = moment(date).startOf('month').subtract(5, 'month').format("YYYY-MM-DD HH:mm:ss");

    this.calendarLine = [];
    for (let x = 0; x < 5; x++) {
      this.calendarLine.push(moment(selectedDate).add(x, 'month').format("YYYY-MM-DD HH:mm:ss"));
    }
    selectedDate = moment(selectedDate).add(2, 'month').format("YYYY-MM-DD HH:mm:ss");
    this.monthClicked(selectedDate);
  }

  nextMonths(date: string) {
    let selectedDate = moment(date).startOf('month').add(5, 'month').format("YYYY-MM-DD HH:mm:ss");

    this.calendarLine = [];
    for (let x = 0; x < 5; x++) {
      this.calendarLine.push(moment(selectedDate).add(x, 'month').format("YYYY-MM-DD HH:mm:ss"));
    }
    selectedDate = moment(selectedDate).add(2, 'month').format("YYYY-MM-DD HH:mm:ss");
    this.monthClicked(selectedDate);
  }

  monthClicked(dateString: string) {
    // let newMonthQuery = `startDate: "${startDate}", endDate: "${endDate}"`;
    // this.queryEvents(newMonthQuery);
    this.goToMonth(dateString);
    // this.innerCalendar.loadMonthEvents(this.monthEvents);
    // this.updateEvents(moment(dateString)); Already being done by this.queryEvents(newMonthQuery);
    this.calendarLoad(dateString);
  }
}


// WEBPACK FOOTER //
// ./src/components/co-calendar/co-calendar.ts